(function () {
  'use strict';

  // === CONFIG ===
  // Les règles sont chargées depuis le métaobjet Shopify `gift_code_rule`
  // (rendu en JSON dans layout/theme.liquid → window.__GIFT_RULES).
  // Le fallback ci-dessous sert uniquement si le métaobjet n'existe pas (dev local).
  const FALLBACK_RULES = {
    
  };
  const GIFT_RULES = (window.__GIFT_RULES && Object.keys(window.__GIFT_RULES).length)
    ? window.__GIFT_RULES
    : FALLBACK_RULES;

  const GIFT_PROP = '_gift_code';
  const DEBUG = false;
  const log = (...a) => DEBUG && console.log('[gift-with-code]', ...a);

  let busy = false;

  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    return r.json();
  }

  function readCodeFromDOM() {
    const el = document.querySelector('#scDiscountApp .code-name, .sc_code-info .code-name');
    return el ? el.textContent.trim().toUpperCase() : null;
  }

  function getActiveCode(cart) {
    const native = (cart.discount_codes || [])
      .filter(d => d.applicable !== false)
      .map(d => (d.code || '').toUpperCase())
      .find(c => GIFT_RULES[c]);
    if (native) return native;

    const dom = readCodeFromDOM();
    if (dom && GIFT_RULES[dom]) return dom;

    return null;
  }

  function giftLinesFor(cart, code) {
    return cart.items.filter(
      item => item.properties && item.properties[GIFT_PROP] === code
    );
  }

  function paidUnitsOfGiftProduct(cart, rule, code) {
    return cart.items
      .filter(it =>
        !(it.properties && it.properties[GIFT_PROP] === code) &&
        (rule.productHandle ? it.handle === rule.productHandle : true)
      )
      .reduce((sum, it) => sum + it.quantity, 0);
  }

  function shouldAddGift(rule, cart, code) {
    const threshold = rule.skipIfPaidUnitsAtLeast ?? Infinity;
    const units = paidUnitsOfGiftProduct(cart, rule, code);
    if (units >= threshold) {
      log('skip add: paid units already >= threshold', { units, threshold });
      return false;
    }
    return true;
  }

  const productCache = {};
  async function getProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    const r = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!r.ok) return null;
    const p = await r.json();
    productCache[handle] = p;
    return p;
  }

  const KNOWN_SIZES = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl', '3xl', '4xl'];

  function variantOptions(v) {
    if (Array.isArray(v.options)) return v.options.filter(Boolean);
    return [v.option1, v.option2, v.option3].filter(Boolean);
  }

  function detectSize(values) {
    return values.map(String).find(v => KNOWN_SIZES.includes(v.trim().toLowerCase())) || null;
  }

  async function resolveGiftVariantId(rule, cart, code) {
    if (!rule.productHandle || rule.productHandle === 'REMPLIR-HANDLE-ICI') {
      return rule.fallbackVariantId;
    }

    const paidItem = cart.items.find(
      it => !(it.properties && it.properties[GIFT_PROP] === code)
    );
    if (!paidItem) {
      log('no paid item, fallback');
      return rule.fallbackVariantId;
    }

    let cartOpts = [paidItem.option1, paidItem.option2, paidItem.option3].filter(Boolean);
    if (!cartOpts.length && Array.isArray(paidItem.variant_options)) {
      cartOpts = paidItem.variant_options.filter(Boolean);
    }
    if (!cartOpts.length && paidItem.variant_title) {
      cartOpts = paidItem.variant_title.split(/\s*\/\s*/).filter(Boolean);
    }
    const cartSize = detectSize(cartOpts);
    log('paid item options', { variant_title: paidItem.variant_title, options: cartOpts, detectedSize: cartSize });

    if (!cartSize) {
      log('no size detected on paid item, fallback');
      return rule.fallbackVariantId;
    }

    const product = await getProduct(rule.productHandle);
    if (!product) {
      log('gift product not found, fallback', { handle: rule.productHandle });
      return rule.fallbackVariantId;
    }

    const fallbackVariant = product.variants.find(v => v.id === rule.fallbackVariantId);
    const fallbackOpts = fallbackVariant ? variantOptions(fallbackVariant) : [];
    const fallbackNonSize = fallbackOpts.filter(o => !KNOWN_SIZES.includes(String(o).toLowerCase()));
    log('fallback variant', { id: rule.fallbackVariantId, options: fallbackOpts });

    const targetSize = cartSize.toLowerCase();
    const match = product.variants.find(v => {
      if (!v.available) return false;
      const opts = variantOptions(v).map(o => String(o).toLowerCase());
      if (!opts.includes(targetSize)) return false;
      // garder les autres dimensions du fallback (ex: "Pack de 2")
      return fallbackNonSize.every(o => opts.includes(String(o).toLowerCase()));
    });

    if (match) {
      log('matched gift variant by size', { size: cartSize, variantId: match.id, options: variantOptions(match) });
      return match.id;
    }

    log('no available variant for size, fallback', {
      size: cartSize,
      availableSizes: product.variants.filter(v => v.available).map(v => variantOptions(v)),
    });
    return rule.fallbackVariantId;
  }

  async function addGifts(code) {
    const rule = GIFT_RULES[code];
    const cart = await getCart();
    const variantId = await resolveGiftVariantId(rule, cart, code);
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: rule.quantity || 1,
          properties: { [GIFT_PROP]: code },
        }],
      }),
    });
    if (!r.ok) console.warn('[gift-with-code] add failed', await r.text());
  }

  async function removeGifts(cart, code) {
    const updates = {};
    cart.items.forEach(item => {
      if (item.properties && item.properties[GIFT_PROP] === code) {
        updates[item.key] = 0;
      }
    });
    if (!Object.keys(updates).length) return;
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates }),
    });
  }

  async function refreshCartUI() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function') {
      try {
        const sections = drawer.getSectionsToRender().map(s => s.id).join(',');
        const url = `/cart?sections=${sections}&sections_url=${encodeURIComponent(window.location.pathname)}`;
        const res = await fetch(url);
        const data = await res.json();
        drawer.renderContents({ sections: data });
        return;
      } catch (e) {
        console.warn('[gift-with-code] drawer refresh failed', e);
      }
    }
    if (window.location.pathname.startsWith('/cart')) {
      window.location.reload();
    }
  }

  async function sync() {
    if (busy) return;
    busy = true;
    try {
      let cart = await getCart();
      const code = getActiveCode(cart);
      let changed = false;

      for (const c of Object.keys(GIFT_RULES)) {
        if (c === code) continue;
        if (giftLinesFor(cart, c).length) {
          await removeGifts(cart, c);
          changed = true;
        }
      }

      if (code) {
        if (changed) cart = await getCart();
        if (!giftLinesFor(cart, code).length && shouldAddGift(GIFT_RULES[code], cart, code)) {
          await addGifts(code);
          changed = true;
        }
      }

      log('sync done', { code, changed });
      if (changed) await refreshCartUI();
    } catch (e) {
      console.error('[gift-with-code] sync error', e);
    } finally {
      busy = false;
    }
  }

  function debounce(fn, ms) {
    let t;
    return () => {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }
  const debouncedSync = debounce(sync, 400);

  window.addEventListener('sc:discount.calculated', debouncedSync);
  window.addEventListener('sc:discount.remove', debouncedSync);

  // === Pré-ajout : injecter le cadeau AVANT que Shop Circle valide le code ===
  // Sans ça, le code est rejeté ("non valide pour les articles de votre panier")
  // car la culotte cadeau n'est pas encore dans le panier.
  function findCodeInputNear(el) {
    const container = el.closest('form, .sc_discount-app, #scDiscountApp, [class*="discount"], [class*="code"]') || document;
    const candidates = container.querySelectorAll(
      'input[name="discount"], input[name*="discount" i], input[name*="code" i], ' +
      'input[placeholder*="code" i], input[placeholder*="promo" i], ' +
      'input[class*="discount" i], input[class*="code" i], ' +
      'input[type="text"], input:not([type])'
    );
    for (const inp of candidates) {
      const v = (inp.value || '').trim().toUpperCase();
      if (v && GIFT_RULES[v]) return { input: inp, code: v };
    }
    return null;
  }

  let bypass = false;

  async function preAddIfGiftCode(triggerEl, originalEvent) {
    if (bypass) return false;
    const hit = findCodeInputNear(triggerEl);
    if (!hit) return false;

    const cart = await getCart();
    if (giftLinesFor(cart, hit.code).length) return false; // déjà là

    originalEvent.preventDefault();
    originalEvent.stopImmediatePropagation();

    try {
      await addGifts(hit.code);
    } catch (e) {
      console.error('[gift-with-code] pre-add failed', e);
      return false;
    }

    // Relance l'action utilisateur, Shop Circle va revalider et accepter le code
    bypass = true;
    setTimeout(() => {
      if (triggerEl.tagName === 'BUTTON' || triggerEl.tagName === 'INPUT' || triggerEl.getAttribute('role') === 'button') {
        triggerEl.click();
      } else if (triggerEl.form) {
        triggerEl.form.requestSubmit ? triggerEl.form.requestSubmit() : triggerEl.form.submit();
      }
      bypass = false;
    }, 150);
    return true;
  }

  document.addEventListener('click', (e) => {
    if (bypass) return;
    const btn = e.target.closest('button, input[type="submit"], [role="button"], a');
    if (!btn) return;
    const txt = (btn.textContent || btn.value || '').trim().toLowerCase();
    const looksLikeApply = /appliqu|apply|valid/.test(txt) ||
      btn.matches('[class*="apply" i], [class*="discount" i], [class*="code" i]');
    if (!looksLikeApply) return;
    log('click apply candidate', { txt: txt.slice(0, 30), btn });
    preAddIfGiftCode(btn, e);
  }, true);

  window.__giftWithCode = {
    sync, addGifts, getCart, GIFT_RULES,
    onDiscountActivation, onCartMutation,
  };

  document.addEventListener('keydown', (e) => {
    if (bypass) return;
    if (e.key !== 'Enter') return;
    const inp = e.target;
    if (!(inp instanceof HTMLInputElement)) return;
    const v = (inp.value || '').trim().toUpperCase();
    if (!GIFT_RULES[v]) return;
    preAddIfGiftCode(inp, e);
  }, true);

  // Hooks appelés par le wrap fetch défini dans theme.liquid (qui est en place plus tôt).
  async function onDiscountActivation(code, proceed) {
    log('intercept /discount/', { code });
    let added = false;
    try {
      const cart = await getCart();
      if (!giftLinesFor(cart, code).length && shouldAddGift(GIFT_RULES[code], cart, code)) {
        await addGifts(code);
        added = true;
        log('pre-added gift', { code });
      }
    } catch (e) {
      console.error('[gift-with-code] pre-add failed', e);
    }
    const result = await proceed();
    if (added) setTimeout(() => refreshCartUI(), 600);
    return result;
  }

  function onCartMutation() {
    debouncedSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(sync, 1200));
  } else {
    setTimeout(sync, 1200);
  }
})();
